.stepper {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  list-style: none;
  margin: 0;
  padding: 0;
}

.step {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) var(--space-3);
  border: 1px solid var(--line-subtle);
  border-radius: var(--radius-pill);
  font-size: var(--text-xs);
  color: var(--ink-muted);
}

/* The current step is marked by weight and border, not colour alone. */
.step[aria-current='step'] {
  border-color: var(--accent);
  color: var(--accent-strong);
  font-weight: 600;
}

/* A finished step reads as settled rather than pending: it keeps a mark of
   its own so the eye can tell "done" from "not reached yet". */
.stepDone {
  border-color: var(--positive);
  color: var(--ink-secondary);
}

.stepNumber {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: var(--radius-pill);
  background: var(--surface-inset);
  font-size: var(--text-2xs);
  font-variant-numeric: tabular-nums;
}

.step[aria-current='step'] .stepNumber {
  background: var(--accent);
  color: var(--on-accent);
}

.stepDone .stepNumber {
  background: var(--positive-wash);
  color: var(--positive);
}
